// extracted by mini-css-extract-plugin
export default {"patientChangeProfile":"patientChangeProfile_patientChangeProfile__Lg0C8","gray":"patientChangeProfile_gray__bZko3","borderPrimary":"patientChangeProfile_borderPrimary__bf-zs"};